export enum PathnameEnum {
  LOGIN_PAGE = '/login',
  MAIN_PAGE = '/main',
  STANDARD_OUTPUT_PAGE = '/output/standard',
  ADULTS_ONLY_OUTPUT_PAGE = '/output/special/adults-only',
  ACTION_GENRE_OUTPUT_PAGE = '/output/special/action-genre',
  BODY_PART_OUTPUT_PAGE = '/output/special/body-part',
  FACIAL_EXPRESSION_OUTPUT_PAGE = '/output/special/facial-expression',
  ETC_OUTPUT_PAGE = '/output/special/etc',
  THREE_D_OUTPUT_PAGE = '/output/3d',
  // ImageListItem component 내 locationPathname.includes('/collections') 여부로 분기처리 적용되어있으므로 수정/추가시 주의
  COLLECTION_LIST_PAGE = '/collections',
  COLLECTION_IMAGE_LIST_PAGE = '/collections/:collectionIdPathParam',
  USED_IMAGE_LIST_PAGE = '/collections/used-image-list',

  ADMIN_ROOT = '/admin',
  ADMIN_IMAGE_LIST_ROOT = '/admin/image-list',
  ADMIN_STANDARD_IMAGE_LIST_PAGE = '/admin/image-list/standard',
  ADMIN_ADULTS_ONLY_IMAGE_LIST_PAGE = '/admin/image-list/adults-only',
  ADMIN_IMAGE_UPLOAD_PAGE = '/admin/image-upload',
  ADMIN_IMAGE_EDIT_ROOT = '/admin/image-edit',
  ADMIN_IMAGE_EDIT_PAGE = '/admin/image-edit/:imageIdPathParam',
  ADMIN_ISSUE_REPORT_LIST_ROOT = '/admin/issue-reports',
  ADMIN_OPEN_ISSUE_REPORT_LIST = '/admin/issue-reports/open',
  ADMIN_RESOLVED_ISSUE_REPORT_LIST = '/admin/issue-reports/resolved',
  ADMIN_DELETED_IMAGE_LIST_PAGE = '/admin/deleted-image-list',
  ADMIN_USER_LIST_PAGE = '/admin/users',
  ADMIN_USER_CREATE_PAGE = '/admin/users/create',
  ADMIN_USER_EDIT_PAGE = '/admin/users/:userIdPathParam/edit'
}
